import * as React from "react";
export default class QuickFilter extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let classes = this.props.selected ? "quick-filter selected" : "quick-filter";
        return (React.createElement("div", { className: classes, onClick: this.props.onClick }, this.props.title));
    }
}
;
//# sourceMappingURL=quick-filter.js.map